import {
	RESET_STATES,
	SET_CONFIGURED_TURBINES,
	SET_CONFIRMATION_DIALOG_STATE,
	SET_SELECTED_REFERENCE_TURBINE,
	SET_SELECTED_TURBINES,
	SET_TURBINE_SEARCH,
	SHOW_CONFIRMATION_DIALOG
} from "./KinematicReplicatorActionsTypes";

export default {
	[SET_CONFIGURED_TURBINES](state, configuredTurbines)
	{
		state.ConfiguredTurbines = configuredTurbines;
	},

	[SHOW_CONFIRMATION_DIALOG](state, confirmationDialogTexts)
	{
		state.ConfirmationDialog.show = confirmationDialogTexts.show;
		state.ConfirmationDialog.title = confirmationDialogTexts.title;
		state.ConfirmationDialog.text = confirmationDialogTexts.text;
	},

	[SET_CONFIRMATION_DIALOG_STATE](state, confirmationDialogTexts = {})
	{
		state.ConfirmationDialog.show = confirmationDialogTexts.show;
		state.ConfirmationDialog.title = confirmationDialogTexts.title;
		state.ConfirmationDialog.text = confirmationDialogTexts.text;
	},

	[SET_SELECTED_REFERENCE_TURBINE](state, referenceTurbine)
	{
		state.SelectedReferenceTurbine = referenceTurbine;
	},

	[SET_SELECTED_TURBINES](state, selectedTurbines)
	{
		state.SelectedTurbines = selectedTurbines;
	},

	[SET_TURBINE_SEARCH](state, valueToSearch)
	{
		state.TurbineSearch = valueToSearch;
	},

	[RESET_STATES](state)
	{
		state.SelectedReferenceTurbine = "";
		state.SelectedTurbines = [];
		state.TurbineSearch = "";
	},
};